export {};
//# sourceMappingURL=interface-types.js.map